import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FlavorDTO } from 'src/app/shared/model/dto/FlavorDTO';
import { PizzaDTO } from 'src/app/shared/model/dto/PizzaDTO';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UtilsService } from 'src/app/core/services/utils.service';

@Component({
	selector: 'app-additional-toppings',
	templateUrl: './additional-toppings.page.html',
	styleUrls: ['./additional-toppings.page.scss'],
})
export class AdditionalToppingsPage implements OnInit {

	@Input() additionalToppings;
	@Input() size: PizzaDTO;
	@Input() pizzaPage;

	flavors: FlavorDTO[];
	selectedFlavorIndex: number;
	checkTopping = [];

	constructor(private modalCtrl: ModalController, private utils: UtilsService, private sanitizer: DomSanitizer) { }

	ngOnInit() {
		this.flavors = this.size.selectedFlavors;
	}

	onSelectFlavor(flavorIndex) {
		this.selectedFlavorIndex = flavorIndex;

        this.additionalToppings.categories.forEach(category => {
            category.options.forEach(topping => {
                this.isToppingAdded(topping);
            });
        });

		this.additionalToppings = JSON.parse(JSON.stringify(this.additionalToppings));
	}

	onSelectTopping(categoryIndex, toppingIndex) {
		let selectedFlavor = this.flavors[this.selectedFlavorIndex];
		let selectedTopping = this.additionalToppings.categories[categoryIndex].options[toppingIndex];
		if(this.isToppingAdded(selectedTopping)) {
			let flavorToppingIndex = selectedFlavor.additionalToppings.findIndex(topping => {
				return topping.id == selectedTopping.id;
			});

			if(flavorToppingIndex != -1) {
                selectedFlavor.additionalToppings.splice(flavorToppingIndex, 1);
                this.size.totalPrice -= selectedTopping.price;            
			}
		}else {
            selectedFlavor.additionalToppings.push(selectedTopping);
            this.size.totalPrice += selectedTopping.price;
		}
	}

	isToppingAdded(topping): boolean {
		this.checkTopping[topping.id] = false;
		this.flavors[this.selectedFlavorIndex].additionalToppings.forEach(_topping => {
			if(_topping.id == topping.id)
				this.checkTopping[topping.id] = true;
		});

		return this.checkTopping[topping.id];
	}

	finishToppings() {
		this.modalCtrl.dismiss({
			'dismissed': true,
			'flavors': this.flavors,
			'finishSize': true
		});
	}

	dismissModal() {
		this.modalCtrl.dismiss({
			'dismissed': true,
			'flavors': this.flavors,
			'finishSize': false
		});
	}

    convertToSafeHtml(rawHtml: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(rawHtml);
    }

    removeHtmlTags(str: string) {
		return this.utils.removeTags(str);
	}

	getSafeHtml(value: any) {
		try {
			const parsedValue = JSON.parse(value);
			const sanitizedValue = this.utils.sanitizeAndFormatText(parsedValue);
			return this.convertToSafeHtml(sanitizedValue);
		} catch (error) {
			const sanitizedValue = this.utils.sanitizeAndFormatText(value);
			return this.removeHtmlTags(sanitizedValue);
		}
	}

    toggleAccordion(categoryId) {
        const accordion = document.getElementById(categoryId);
        accordion.classList.toggle('show');

        const icon = document.getElementById(`${categoryId}-icon`);
        icon.classList.toggle('rotate-180');
    }
}
